import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  planDetails: '',
  planProducts: {},
  selectedPlanProduct: {},
  openAddressForm: false,
  modal: {
    showEligibilityModal: false,
  },
  fields: {
    uniqueID: '',
    // consent: [],
  },
  planFilterUniqueID: '',
  filteredPlans: '',
  activationCode: '',
  showOptions: {
    uniqueID: '',
    consent: '',
  },
  message: {},
  uniqueIDDetails: {
    isValid: false,
    isEligible: false,
    message: {},
  },
  isDisabled: true,
  ipidUrl: {},
  otherRelatedDocsUrl: {},
  showConsentModal: false,
  invalidDOBModal: {
    showInvalidDOBModal: false,
    invalidMessage: '',
  },
  showDataRecheckModal: false,
  taxAddress: null,
  planPurchaseDetails: {},
  paymentParamsRequired: false,
  requiredPaymentParams: {},
}

const detailsSlice = createSlice({
  name: 'detailsSlice',
  initialState,
  reducers: {
    setPlanDetails: (state, action) => {
      state.planDetails = action.payload
    },
    setPlanProductDetails: (state, action) => {
      state.planProducts = action.payload
    },
    setOpenAddressForm: (state, action) => {
      state.openAddressForm = action.payload
    },
    setSelectedPlanProduct: (state, action) => {
      state.selectedPlanProduct = action.payload
    },
    setIsPlanPurchaseInProcess: (state, action) => {
      state.isPlanPurchaseInProcess = action.payload
    },
    setModal: (state, action) => {
      state.modal = action.payload
    },
    setFields: (state, action) => {
      state.fields = { ...state.fields, ...action.payload }
    },
    clearFields: (state) => {
      state.fields = {}
    },
    setPlanFilterUniqueID: (state, action) => {
      state.planFilterUniqueID = action.payload
    },
    setFilteredPlans: (state, action) => {
      state.filteredPlans = action.payload
    },
    setActivationCode: (state, action) => {
      state.activationCode = action.payload
    },
    setShowOptions: (state, action) => {
      state.showOptions = action.payload
    },
    setVerifiedOptions: (state, action) => {
      state.verifiedOptions = action.payload
    },
    setMessage: (state, action) => {
      state.message = action.payload
    },
    setUniqueIDDetails: (state, action) => {
      state.uniqueIDDetails = action.payload
    },
    setIsDisabled: (state, action) => {
      state.isDisabled = action.payload
    },
    setIpIdUrl: (state, action) => {
      state.ipidUrl = action.payload
    },
    setOtherRelatedDocsUrl: (state, action) => {
      state.otherRelatedDocsUrl = action.payload
    },
    setModalConsents: (state, action) => {
      state.modalConsents = action.payload
    },
    setShowConsentModal: (state, action) => {
      state.showConsentModal = action.payload
    },
    setInvalidDOBModal: (state, action) => {
      state.invalidDOBModal = action.payload
    },
    setShowDataRecheckModal: (state, action) => {
      state.showDataRecheckModal = action.payload
    },
    setIsLoggedInFromStore: (state, action) => {
      state.isLoggedInFromStore = action.payload
    },
    setPlanPurchaseDetails: (state, action) => {
      state.planPurchaseDetails = { ...state.planPurchaseDetails, ...action.payload }
    },
    setPlanPriceByProduct: (state, action) => {
      state.planPriceByProduct = action.payload
    },
    setProductDetails: (state, action) => {
      state.productDetails = action.payload
    },
    setPurchaseDetails: (state, action) => {
      state.purchaseDetails = action.payload
    },
    setTaxAddress: (state, action) => {
      state.taxAddress = action.payload
    },
    setPaymentParamsRequired: (state, action) => {
      state.paymentParamsRequired = action.payload // For getRequiredPaymentParamsList
    },
    setRequiredPaymentParams: (state, action) => {
      state.requiredPaymentParams = action.payload
    },
    setSelectedAddress: (state, action) => {
      state.selectedAddress = action.payload
    },
    setPlanPaymentDetails: (state, action) => {
      state.planPaymentDetails = action.payload
    },
  },
})

export default detailsSlice.reducer

export const {
  setPlanDetails,
  setPlanProductDetails,
  setSelectedPlanProduct,
  setIsPlanPurchaseInProcess,
  setOpenAddressForm,
  setModal,
  setFields,
  clearFields,
  setPlanFilterUniqueID,
  setFilteredPlans,
  setActivationCode,
  setShowOptions,
  setMessage,
  setUniqueIDDetails,
  setIsDisabled,
  setIpIdUrl,
  setOtherRelatedDocsUrl,
  setModalConsents,
  setShowConsentModal,
  setInvalidDOBModal,
  setShowDataRecheckModal,
  setIsLoggedInFromStore,
  setPlanPurchaseDetails,
  setPlanPriceByProduct,
  setProductDetails,
  setPurchaseDetails,
  setTaxAddress,
  setPaymentParamsRequired,
  setRequiredPaymentParams,
  setSelectedAddress,
  setPlanPaymentDetails,
} = detailsSlice.actions
